import { useMutation } from "@apollo/client/react";

import { reportAppError } from '@anyx/shared-utils';

import { GENERATE_TRACKING_URL } from '../graphql';
import { TrackingUrlArray } from '../types';

export const useGenerateTrackingUrl = () => {
  const [mutate] = useMutation(GENERATE_TRACKING_URL);

  const generateTrackingUrls = async (
    urls: string[],
    opts: { urlLinkGroupId: string; shorten?: boolean }
  ): Promise<TrackingUrlArray> => {
    try {
      const { urlLinkGroupId, shorten = false } = opts;
      const trackingUrls = await mutate({
        variables: {
          input: {
            urlLinkGroupId,
            shorten,
            urls,
          },
        },
      });

      return (trackingUrls.data?.GenerateTrackingUrl || []).map(
        ({ originalUrl, trackingUrl, shortUrl }) => ({
          originalUrl,
          trackingUrl,
          shortUrl: shortUrl ?? undefined,
        })
      );
    } catch (error) {
      reportAppError(error);
      return [];
    }
  };

  return {
    generateTrackingUrls,
  };
};
